import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import videojs from 'video.js';
import { useTranslation } from 'react-i18next';

import "./BrightcovePlayer.css"

export const BrightcovePlayer = ({
    accountId,
    playerId, 
    videoId,
    poster = undefined,
    loop = false,
    autoplay = false,
    onLoadedCallBack = () => {},
    controls = true
}) => {

    const { i18n } = useTranslation();

    const videoPlayerId = "videoPlayer";
    
    useEffect(() => {
        loadBrightcoveScript();
    }, [null]);

    const setCaptionLanguage = () => {
        var brightcovePlayer = videojs.getPlayer(videoPlayerId);

        var browser_language = i18n.language;

        // Make sure we are using the same language/region separator when comparing language codes.
        browser_language = browser_language.toLowerCase().replace("_", "-");
        
        var track_language;
        var tracks = brightcovePlayer.textTracks();
        
        var found_track = false;

        // First try to find an exact match (language + region)
        for (let i = 0; i < (tracks.length); i++) {
            // Match the language/region separator to the one above.
            track_language = tracks[i].language.toLowerCase().replace("_", "-");

            // When the caption language equals the browser language, then set it as default
            if (track_language) {
                if (track_language === browser_language) {
                    tracks[i].mode = "showing";
                    found_track = true;
                } else {
                    tracks[i].mode = "disabled";
                }
            }
        }

        // If we haven't found a match, try to match by just the language
        if (!found_track) {
            browser_language = browser_language.slice(0, 2);

            for (let i = 0; i < (tracks.length); i++) {
                track_language = tracks[i].language.slice(0, 2).toLowerCase();
                
                // When the caption language equals the browser language, then set it as default
                if (track_language) {
                    if (track_language === browser_language) {
                        tracks[i].mode = "showing";
                        found_track = true;
                    } else {
                        tracks[i].mode = "disabled";
                    }
                }
            }
        }

        onLoadedCallBack();

    };

    const onBrightcoveScriptLoad = () => {
        videojs.getPlayer(videoPlayerId).ready(function () {
            var brightcovePlayer = this;
            brightcovePlayer.on("loadeddata", setCaptionLanguage);
        });
    };

    const loadBrightcoveScript = () => {
        const scriptTagId = `brightcovePlayer-${accountId}-${playerId}}`;
        const brightcoveScriptTag = document.getElementById(scriptTagId);

        if (brightcoveScriptTag) {
            brightcoveScriptTag.parentElement.removeChild(brightcoveScriptTag);
        }

        const domHead = document.getElementsByTagName("head")[0];

        const scriptTag = document.createElement("script");

        scriptTag.type = "text/javascript";
        scriptTag.id = scriptTagId;
        scriptTag.async = true;
        scriptTag.onload = onBrightcoveScriptLoad;
        scriptTag.src = `https://players.brightcove.net/${accountId}/${playerId}_default/index.min.js`;
        domHead.appendChild(scriptTag);
    }
    
    return(
        <Box id="brightcovePlayer" sx={{
            maxWidth: "1080px",
            aspectRatio: 1
        }}>
            <video-js
                id={videoPlayerId}
                data-account={accountId}
                data-player={playerId}
                data-embed="default"
                data-video-id={videoId}
                data-playlist-id=""
                data-application-id=""
                class="vjs-fill"
                loop={loop}
                {...(autoplay ? {autoplay: ""} : {})}
                {...(poster !== undefined ? {poster: {poster}} : {})}
                {...(controls ? {controls: ""} : {})}
            />
        </Box>
    );
}
BrightcovePlayer.propTypes = {
    playerId: PropTypes.string.isRequired,
    accountId: PropTypes.string.isRequired,
    videoId: PropTypes.string.isRequired,
    poster: PropTypes.string,
    loop: PropTypes.bool,
    autoplay: PropTypes.bool,
    onLoadedCallBack: PropTypes.func,
    controls: PropTypes.bool
}

export default BrightcovePlayer;